export default __webpack_public_path__ + "assets/images/abe8f0f85b2137a1b21fd6b93c788ffc.png";